module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/chart-line-2-9b5cb7f27c77a2173335430e927cb384.svg";